import { useContext } from 'react';
import { useNavigate, Link } from 'react-router-dom';

import FollowerList from './FollowerList';
import AuthContext from '../../../api/AuthProvider';
import { default as FinspaceLogo } from '../../../assets/FinspaceLogo.svg';

const SidebarLeft = (props) => {
    const { followers, usersFollowed } = props;
    const { user } = useContext(AuthContext);
    const navigate = useNavigate();

    return (
        <div className="sidebar">
            <div className="sidebar-logo">
                <img
                    alt="logo"
                    className="sidebar-logo-button"
                    onClick={() => navigate('/feed')}
                    src={FinspaceLogo}
                />
            </div>
            <div className="sidebar-item">
                <ul className="sidebar-nav-list">
                    <li className="sidebar-nav-list-item">
                        <i className="bi-newspaper bi-icon-sm" />
                        <Link to="/feed">Feed</Link>
                    </li>
                    <li className="sidebar-nav-list-item">
                        <i className="bi-briefcase bi-icon-sm" />
                        <Link to="/portfolio">My Portfolio</Link>
                    </li>
                    <li className="sidebar-nav-list-item">
                        <i className="bi-clipboard-data bi-icon-sm" />
                        <Link to="/boards">Analysis Boards</Link>
                    </li>
                    <li className="sidebar-nav-list-item">
                        <i className="bi-graph-up-arrow bi-icon-sm" />
                        <Link to="/macro">Macro Analysis</Link>
                    </li>

                    <li className="sidebar-nav-list-item">
                        <i className="bi-person-circle bi-icon-sm" />
                        <Link reloadDocument to={'/profile/' + user.username}>
                            Profile
                        </Link>
                    </li>
                </ul>
            </div>
            <FollowerList followers={followers} usersFollowed={usersFollowed} />
        </div>
    );
};

export default SidebarLeft;
